import type { ReactNode } from "react";

import { EvvyMarkdown } from "@/components/common/evvyMarkdown";

interface Props {
  name: string;
  description: string;
  price?: ReactNode;
  image_url?: string;
  children?: ReactNode;
}

export const CARD_CLASSES =
  "border border-[var(--chat-grey-100)] rounded-[var(--chat-corner-base)] p-[var(--chat-space-04)] max-w-[var(--chat-max-bubble)]";

export default function ChatProductCard({
  name,
  description,
  price,
  image_url,
  children,
}: Props) {
  const details = (
    <div className="flex flex-1 gap-[var(--chat-space-03)] items-start min-w-0">
      {image_url && (
        <img
          src={image_url}
          // Decorative: the name is printed beside it.
          alt=""
          className="w-[100px] h-[67px] object-cover rounded-[var(--chat-corner-sm)] shrink-0"
        />
      )}
      <div className="flex flex-col gap-[var(--chat-space-02)] justify-center min-w-0">
        <p className="m-0 text-[var(--chat-text-base)] font-medium leading-[1.5] text-[var(--chat-black)]">
          {name}
        </p>
        {/* Catalog text, rendered as the shop renders it. A div: multi-paragraph markdown is block-level. */}
        {description && (
          <div className="text-[length:var(--chat-text-xs)] leading-[1.5] text-[var(--chat-grey-500)]">
            <EvvyMarkdown>{description}</EvvyMarkdown>
          </div>
        )}
        {price && (
          <p className="m-0 text-[var(--chat-text-xs)] font-semibold leading-[1.5] text-[var(--chat-black)]">
            {price}
          </p>
        )}
      </div>
    </div>
  );

  return (
    <div
      className={`flex flex-col gap-[var(--chat-space-04)] w-full ${CARD_CLASSES}`}
    >
      {details}
      {children}
    </div>
  );
}
